// extracted by mini-css-extract-plugin
export default {"MainConatiner":"SocialHome_MainConatiner__W9VG+"};